import { noneProfile } from "assets";
import ImageUrl from "components/app/image-url/ImageUrl";
import { BookUser, Loader, LoaderCircle } from "lucide-react";

import InfiniteScroll from "react-infinite-scroll-component";
import { useAppSelector } from "store/store";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import NumberInput from "components/app/function/NumberInput";
import { Button } from "components/ui/button";

const LeaveCard = ({
  shopEmployeeLeave,
  fetchMoreShopEmployeeLeaveSearch,
  shopEmployeeLeaveLoading,
  listRef,
  selectedMonth,
  selectProducts,
  setSelectedProductIds,
  selectedProductIds,
  setOpenDrawer,
  getShopEmployeeLeaveDetail,
  openPopoverKey,
  setOpenPopoverKey,
  setMonthTableClick,
  monthDay,
  handleChangeMonth,
  saveUpdateLeaveDeduction,
  loadingsubmitUpdateLeaveDeduction,
}: any) => {
  const { indexTimeSheet } = useAppSelector((state) => state.header);

  return (
    <InfiniteScroll
      dataLength={shopEmployeeLeave?.data?.length || 0}
      next={() =>
        fetchMoreShopEmployeeLeaveSearch({
          next: shopEmployeeLeaveLoading.nextPageUrl,
        })
      }
      hasMore={!!shopEmployeeLeaveLoading?.nextPageUrl}
      loader={
        <div className="absolute bottom-2 left-0 w-full flex justify-center">
          <LoaderCircle size={30} className="animate-spin text-yellow-400" />
        </div>
      }
    >
      <>
        <div ref={listRef} className={`grid  md:grid-cols-5 grid-cols-2 ${window.innerWidth <= 1500 ? "lg:grid-cols-6" : "lg:grid-cols-8"}  gap-y-3 gap-x-2 mb-10   `}>
          {shopEmployeeLeave?.data?.map((item: any, index: any) => {
            const monthMap = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
            const currentMonthIndex = selectedMonth;
            const prevMonthIndex = currentMonthIndex - 1;
            const previousEndDayValue = prevMonthIndex >= 0 ? item[`${monthMap[prevMonthIndex]}_end_day`] ?? "-" : "-";
            const currentMonthKey = monthMap[selectedMonth];
            const usedKey = `${currentMonthKey}_used_day`;
            const endKey = `${currentMonthKey}_end_day`;
            const month = monthMap[selectedMonth];
            const usedDay = item[usedKey];
            const endDay = item[endKey];
            if (!usedDay && !endDay) return null;
            const editable = usedDay === "0.000";
            const keyId = `${index}-${month}`;
            return (
              <div
                onClick={() => {
                  if (selectProducts) {
                    setSelectedProductIds((prev: any) => (prev.includes(item.id) ? prev.filter((id: number) => id !== item.id) : [...prev, item.id]));
                    return;
                  } else {
                  }
                }}
                key={index}
                className={`group   relative z-1 w-full max-w-sm border rounded-lg  ${selectedProductIds.includes(item.id) ? " " : ""}`}
              >
                <div className=" w-full relative overflow-hidden aspect-square ">
                  <ImageUrl className="rounded-t-md w-full h-full  object-cover " src={!item.picture ? noneProfile : item.picture} alt="" />
                  <div
                    className={` ${selectedProductIds.includes(item.id) ? "bg-white" : ""} w-4 h-4 rounded-full flex items-center justify-center absolute left-2 top-2 text-xl  ${
                      !selectProducts ? " hidden" : " block"
                    }`}
                  >
                    {selectedProductIds.includes(item.id) ? (
                      <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                    ) : (
                      <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full"></i>
                    )}
                  </div>
                  <div
                    onClick={() => {
                      setOpenDrawer(1);
                      getShopEmployeeLeaveDetail(item?.employee_id, item?.leave_type);
                    }}
                    className={`${
                      selectProducts ? " hidden" : " block"
                    } z-50 cursor-pointer group-hover:scale-110 transition-all duration-300 group-hover:opacity-100 opacity-0 w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full absolute right-2 top-2`}
                  >
                    <BookUser />
                  </div>
                </div>
                <div className={`p-4 ${indexTimeSheet === item.id ? "bg-gray-200 dark:bg-[#0e172c] rounded-b-md " : ""} `}>
                  <h5 className="text-md font-semibold line-clamp-2 overflow-hidden h-[20px] ">{item?.local_name}</h5>
                  <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{item?.department}</span>
                  <div key={index} className="flex items-center justify-between mt-2">
                    <div className="flex flex-col justify-between h-[60px]">
                      <p
                        className={` text-white px-2 my-1 inline-block rounded-md py-1 ${
                          item.leave_type === "Annual Leave" ? "bg-green-500" : item.leave_type === "Sick Leave" ? "bg-[#a657f6] " : "bg-red-700"
                        } font-semibold text-sm  line-clamp-1`}
                      >
                        {item.leave_type.replace(/-/g, " ")}
                      </p>

                      <p className="font-bold  text-[15px]  text-yellow-500 ">{previousEndDayValue > 0 ? previousEndDayValue + " days" : ""} </p>
                    </div>
                    <div key={index} className="flex flex-col items-end text-end h-[60px] justify-between ">
                      {/* Used Day Popover */}
                      <Popover
                        open={openPopoverKey?.row === index && openPopoverKey?.month === month}
                        onOpenChange={(isOpen) => setOpenPopoverKey(isOpen ? { row: index, month } : null)}
                      >
                        <PopoverTrigger asChild>
                          {editable ? (
                            <p onClick={() => setMonthTableClick(false)} className=" text-lg text-black dark:text-white text-end cursor-pointer">
                              -
                            </p>
                          ) : (
                            <p onClick={() => setMonthTableClick(false)} className={`font-bold text-[15px] text-red-500 cursor-pointer py-2 `}>
                              {usedDay}
                            </p>
                          )}
                        </PopoverTrigger>
                        <PopoverContent className="w-auto">
                          <div className="flex items-center gap-2">
                            <NumberInput className="w-[150px]" value={monthDay[keyId] || ""} onChange={(val: any) => handleChangeMonth(keyId, val.target.value)} />
                            <Button className="px-5 dark:text-white" onClick={() => saveUpdateLeaveDeduction(keyId, item.id)}>
                              {loadingsubmitUpdateLeaveDeduction ? <Loader className="animate-spin" /> : "Save"}
                            </Button>
                          </div>
                        </PopoverContent>
                      </Popover>

                      {/* End Day Popover */}
                      {endDay === "0.000" ? <p className=" text-lg text-black dark:text-white">-</p> : <p className="text-blue-500 font-bold  text-[15px] ">{endDay}</p>}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          {!shopEmployeeLeave?.next_page_url ? (
            <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
              <b>Nothing more to load!</b>
            </p>
          ) : (
            ""
          )}
        </div>
      </>
    </InfiniteScroll>
  );
};

export default LeaveCard;
